import { Chip, Row } from "@narmi/design_system";

import styles from "./SectionHeader.module.scss";

interface SectionHeaderProps {
  title: string;
  isOpen: boolean;
  // create mode numbers the sections
  stepNumber?: number;
  isComplete?: boolean;
  badgeLabel?: string;
}

const SectionHeader = ({
  title,
  isOpen,
  stepNumber,
  isComplete = false,
  badgeLabel,
}: SectionHeaderProps) => (
  <Row alignItems="center" gapSize="s" className="padding--all--l">
    {stepNumber ? (
      <Row.Item shrink>
        <span className={styles.stepNumber}>{stepNumber}</span>
      </Row.Item>
    ) : null}
    <Row.Item shrink>
      <h4 className="fontFamily--body fontSize--l">{title}</h4>
    </Row.Item>
    {isComplete ? (
      <Row.Item shrink>
        <span className="narmi-icon-check fontColor--theme--secondary" />
      </Row.Item>
    ) : null}
    {badgeLabel ? (
      <Row.Item shrink>
        <Chip kind="warn" label={badgeLabel} />
      </Row.Item>
    ) : null}
    <Row.Item />
    <Row.Item shrink>
      <span
        className={isOpen ? "narmi-icon-chevron-up" : "narmi-icon-chevron-down"}
      />
    </Row.Item>
  </Row>
);

export default SectionHeader;
